// extracted by mini-css-extract-plugin
export default {"innerWrapper":"LA-z","tooltipWrapper":"MA-z","icon":"NA-z","tooltip":"OA-z","content":"PA-z"};